module.exports = {
  dimensions: {
    width: 296,
    height: 44
  },
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};